import Image from 'next/image';

import { linkRoutes } from '../../../config/routes/links';
import { pageRoute } from '../../../config/routes/pages';
import SidebarItem from '../../atoms/sidebar-item/sidebar-item';
import CustomLink from '../../atoms/custom-link/custom-link';

export function Sidebar() {
  return (
    <div className="p-4 space-y-4 text-subtitle px-2">
      <p className="text-primaryGray text-3header6">SUPPORT AND SERVICE</p>
      <div className="flex flex-col space-y-4">
        <SidebarItem>
          <Image
            alt="hotline icon"
            height={70}
            src="/icons/sidebar-phone.jpeg"
            width={70}
          />
          <CustomLink
            ctaAdditionalLabel="+63917.1200.111"
            ctaLink={linkRoutes.VIBER}
            text="FGI Customer Service Hotline"
            style="font-MuseoSans100 text-subtitle px-2"
          />
        </SidebarItem>

        <SidebarItem>
          <Image
            alt="manual icon"
            height={70}
            src="/icons/sidebar-manual.jpeg"
            width={70}
          />
          <CustomLink
            ctaAdditionalLabel="Manual and Guides"
            ctaLink={pageRoute.MANUALS_AND_GUIDES}
            text="Sub-Zero and Wolf"
            style="font-MuseoSans100 text-subtitle px-2"
          />
        </SidebarItem>

        <SidebarItem>
          <Image
            alt="brands icon"
            height={70}
            src="/icons/sidebar-brand-logos.jpeg"
            width={70}
          />
          <CustomLink
            ctaAdditionalLabel="Use and Care Videos"
            ctaLink={pageRoute.USE_AND_CARE_VIDEOS}
            text="Sub-Zero and Wolf"
            style="font-MuseoSans100 text-subtitle px-2"
          />
        </SidebarItem>
      </div>
    </div>
  );
}

export default Sidebar;
